// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 405) return "static/chunks/405.d00edfbaccb674b3.js";
	if (chunkId === 281) return "static/chunks/281.38ef7d80b271ba76.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"22":"8cbe08c9894df25a","155":"4aac318160168076","812":"14bc97d1c30cd567","939":"163c022470a9e51a"}[chunkId] + ".js";
};